export default "/static/media/warning.f0206a240feb1b8148e603517fca3ddc.svg";